import React, { createContext, useContext, useState, ReactNode } from "react";
interface LogoutContextType {
  isSessionExpired: boolean;
  isUnauthorized: boolean;
  handleLogout: () => void;
  handleSessionExpired: () => void;
  handleSessionExpiredConfirm: () => void;
  handleUnauthorized: () => void;
  handleUnauthorizedConfirm: () => void;
}

const LogoutContext = createContext<LogoutContextType | undefined>(undefined);

export const useLogout = (): LogoutContextType => {
  const context = useContext(LogoutContext);
  if (!context) {
    throw new Error("useLogout must be used within a LogoutProvider");
  }
  return context;
};
interface LogoutProviderProps {
  children: ReactNode;
}

export const LogoutProvider: React.FC<LogoutProviderProps> = ({ children }) => {
  const [isSessionExpired, setIsSessionExpired] = useState<boolean>(false);
  const [isUnauthorized, setIsUnauthorized] = useState<boolean>(false);

  const handleLogout = (): void => {
    setIsSessionExpired(false);
    localStorage.clear();
    sessionStorage.clear();
    window.location.replace('/');
  };

  const handleUnauthorized = (): void => {
    setIsUnauthorized(true);
  };

  const handleSessionExpired = (): void => {
    setIsSessionExpired(true);
  };

  const handleSessionExpiredConfirm = (): void => {
    setIsSessionExpired(false);
    localStorage.clear();
    sessionStorage.clear();
    window.location.replace('/');
  };

  const handleUnauthorizedConfirm = (): void => {
    setIsUnauthorized(false);
    localStorage.clear();
    sessionStorage.clear();
    window.location.replace('/');
  };

  return (
    <LogoutContext.Provider
      value={{
        isSessionExpired,
        isUnauthorized,
        handleLogout,
        handleSessionExpired,
        handleSessionExpiredConfirm,
        handleUnauthorized,
        handleUnauthorizedConfirm,
      }}
    >
      {children}
    </LogoutContext.Provider>
  );
};
